import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { Text } from 'react-native';
import Guid from '../../../../../src/utils/guid';
import config from "../../../../../src/data/settings";
import { LoadingCircle } from '../../../../../src/components/common/loading';

class IdConnect extends PureComponent {

  constructor(props) {
    super(props);

  }
  componentDidMount(){
    const { auth } = this.props;
    this.props.platform.detectBrowser();
    this.props.chAuth.callAuthentication();
    this.props.loginTerms.onGetPdf();
  }

  render(){
    const ret = window.ret;
    const { i18n: { messages } } = this.props;
    if (ret == "" || ret == null) { 
      return (<div style={{'display': 'flex', 'textAlign': 'center', 'flexDirection': 'column', 'height': '100px'}}>{messages['app.marque.unExpectederror']}</div>);
    } 
    return (
      <div>
        { (parseInt(ret) === 0) &&
          <div>
            <LoadingCircle isPage={true}/>
          </div>
        }
        { (parseInt(ret) != 0) &&
          <div style={{'display': 'flex', 'textAlign': 'center', 'flexDirection': 'column', 'height': '100px'}}>
            { ret == 401 && messages['app.login.auth.error.expiredIDToken']}
            { ret == 405 && messages['app.login.auth.error.invalidRMAccess']}
            { ret == 404 && messages['app.login.auth.error.userNotFound']}
            { ret != 401 && ret != 405 && ret != 404 && ret != 0  &&  messages['app.marque.unExpectederror']}
           
          </div>
        }
      </div>
    );
  }
}

export default createContainer({
  // $renderLoading: () => <LoadingCircle isPage={true}/>,
  $queries: {
    chAuth:{
      callAuthentication: { $call: 'login' }
    },
    platform:{
      detectBrowser: { $call: 'initBrowser'},
    },
    loginTerms: {
      onGetPdf: {$call: 'getPdfLink'},
    },
    i18n: {
      messages: true,
    }
    // queryString:{
    //   callExtractParams:{ $call: 'extract' },
    // }
  }
})(IdConnect);
